define('ET/ETView',[
    "evertrue",
    "jquery",
    "underscore",
    "backbone",
    "parsley",
    "bootstrapTooltip"
], function ETViewFactory ( EverTrue, $, _, Backbone) {

    // override backbone delegate events to use
    // Cached regex to split keys for `delegate`.
    var delegateEventSplitter = /^(\S+)\s*(.*)$/;

    // Extend the bacbone Model with our EverTrue model w/ defualt functionality
    var ETView = Backbone.View.extend({
        modals : {},
        subViews : {},
        delegateEvents : function(events) {
            if (!(events || (events = window.getValue(this, 'events')))) return;
            this.undelegateEvents();
            for (var key in events) {
                var method = events[key];
                if (!_.isFunction(method)) method = this[events[key]];
                if (!method) throw new Error('Method "' + events[key] + '" does not exist');
                var match = key.match(delegateEventSplitter);
                var eventName = match[1], selector = match[2];
                method = _.bind(method, this);
                eventName += '.delegateEvents' + this.cid;
                if (selector === '') {
                    this.$el.bind(eventName, method);
                } else {
                    this.$el.delegate(selector, eventName, method);
                }
            }
        },

        undelegateEvents : function() {
            this.$el.unbind('.delegateEvents' + this.cid);
            // kill all onpress events for this view
            if (typeof $.fn.offPress == 'function') this.$el.offpress();
        },

        _destroy : function(view){
            view = view || this;
            // kill it as a backbone view + unbind its events
            // remove it from the dom i.e kill this.$el
            view.remove();
            // remove it from the view stack
            // unbind view events
            view.unbind();
            // kill events associated with the views models and collections
            if (view.model) view.model.off(null,null,view);
            if (view.collection) view.collection.off(null,null,view);
        },

        destroy : function(){
            var that = this;
            // kill this views subviews and modals
            // _.each(this.subViews, function(view, key){
            //  if(view instanceof Backbone.View) that._destroy(view);
            // });
            // _.each(this.modals, function(view, key){
            //  if(view instanceof Backbone.View) that._destroy(view);
            // });
            //
            // kill this view
            this._destroy();
        },

        loading: function(on, $element) {
            $element = $element || this.$el;

            if (on) {
                $element.css({position: 'relative'});
                $element.prepend("<div class='loading-overlay'><i class='icon-spinner icon-spin icon-large reach-users-spinner'></i></div>");
            } else {
                $element.find('.loading-overlay').remove();
            }
        },

        overflowTooltipInit: function(e) {
            this.$el.find(".ellipsis-overflow").tooltip({
                trigger: "hover",
                placement: "top",
                delay: {show: 500, hide: 0}
            });
        },

        initializePlugins: function(collection){
            this.initializeParsley(collection);
            this.initializeBootstrapPlugins();
        },

        initializeBootstrapPlugins: function(){
            // Enable tooltips
            $tips = this.$('.tip');
            $tips.each(function(ind, el){
                $(el).tooltip();
            });
        },

        initializeParsley : function(collection){
            this.$form = this.$('form');
            this.$form.parsley({
                validationMinlength: 5,
                successClass: '',
                errorClass: 'error',
                errors: {
                    classHandler: function(el) {
                        return $(el).closest('.control-group');
                    },
                    errorsWrapper: '<span class=\"help-inline\"></span>',
                    errorElem: '<span></span>'
                },
                validators: {
                    emails: function(val) {
                      var email, emails, ret, _i, _len;
                      emails = val.split(',');
                      ret = true;
                      for (_i = 0, _len = emails.length; _i < _len; _i++) {
                        email = emails[_i];
                        // trim the email so we can support spaces
                        email = email.trim();
                        ret = this.type(email, 'email');
                      }
                      return ret;
                    },
                    user_email: function(email) {
                        if (collection && collection.length > 0) {
                            var emails = email.split(","),
                                ret = true;
                            _.each(emails, function(email) {
                                var em = email.replace(/ /g,"");
                                if (!collection.findWhere({"email": em})) {
                                    ret = false;
                                }
                            });
                            return ret;
                        } else {
                            return false;
                        }
                    }
                },
                messages: {
                    type : {
                        urlstrict:  "This value should be a valid url starting with http:// or https://"
                    },
                    emails: "This value should be a comma separated list of emails. ",
                    user_email: "All of the emails specified must be users. "
                }
            });
        },

        validate : function() {
            // validate the form using parsley
            var valid = this.$form.parsley( 'validate' );
            if (!valid) return false;
            // check for any evertrue errors
            $errorList = this.$('.et-error-list');
            if ($errorList.length){
                $errorItems = $errorList.find('span');
                if ($errorItems.length){
                    return false;
                }
            }
            return true;
        }
    });

    ETView.include = EverTrue.include;
    return ETView;

});

